module.exports = "fragment SalesEngineer on EmployeeType{__typename id rowId fullName code user{__typename id isActive}}"